import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00dcf83a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "iconsContainer"
}
const _hoisted_2 = ["href", "title"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-phone" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["href", "title"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-comment" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["href", "title"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-comments" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["href", "title"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-comments" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.phoneNumberUnmasked !== undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
          target: "_blank",
          href: 'tel:' + _ctx.phoneNumberUnmasked ,
          title: 'Appeler le ' + $props.linkToPhoneNumber
        }, _hoisted_4, 8, _hoisted_2),
        _createElementVNode("a", {
          target: "_blank",
          href: 'sms:' + _ctx.phoneNumberUnmasked ,
          title: 'Envoyer un message au ' + $props.linkToPhoneNumber
        }, _hoisted_7, 8, _hoisted_5),
        _createElementVNode("a", {
          target: "_blank",
          href: 'https://wa.me/33' + _ctx.phoneNumberUnmaskedAndInt + '?text=Je%20suis%20intéressé%20par%20la%20sortie%20VTT',
          title: 'Discuter sur WhapsApp le ' + $props.linkToPhoneNumber
        }, _hoisted_10, 8, _hoisted_8),
        _createElementVNode("a", {
          target: "_blank",
          href: 'whatsapp://send?phone=33' + _ctx.phoneNumberUnmaskedAndInt + '&text=Je%20suis%20intéressé%20par%20la%20sortie%20VTT',
          title: 'Discuter sur WhapsApp le ' + $props.linkToPhoneNumber
        }, _hoisted_13, 8, _hoisted_11)
      ]))
    : _createCommentVNode("", true)
}